import { goalbookUrls } from '@/links'
export { RequestHandler, createHandleRequest, refreshJwtToken, getCookie, setCrossSiteLogin }

class RequestHandler {
  static handleRequest = null;

  static setupHandleRequest(loginFunction) {
     this.handleRequest = createHandleRequest(loginFunction)
     return this.handleRequest
  }

  static getHandleRequest() {
    return this.handleRequest
  }
}

function createHandleRequest(loginFn) {
  return async function handleRequest({requestFn, refreshFn = refreshJwtToken}, ...args) {
    const res = await requestFn(...args)
    if (!res.ok) {
        // If the request fails, JWT access token may be expired. Try to refresh tokens.
        const refreshRes = await refreshFn()
        if (refreshRes.ok) {
            const response = await requestFn(...args)
            try {
              const res = await response.json()
              return res
            } catch {
              return response
            }
        } else {
            // If the refresh token is also expired, they need to log in again.
            try {
                const status = await loginFn()
                if (status.message === 'success') {
                    // If they log in successfully, they should have new access and refresh tokens. So try the request for content again
                    return handleRequest({requestFn, refreshFn, loginFn}, ...args);
                }
            } catch (e) {
                throw new Error('Error with re-authentication', {cause: e})
            }
        }
    }
    try {
      const json = await res.json()
      return json
    } catch {
      return res
    }
  }
}

async function refreshJwtToken() {
  const response = await fetch(`${goalbookUrls.accounts}/auth/refresh`, {
    credentials: 'include',
    method: 'POST',
  })
  return response
}

async function setCrossSiteLogin() {
  const response = await fetch(`${goalbookUrls.accounts}/users/sign_in`, {
    credentials: 'include',
    method: 'GET',
  })
  return response
}

function getCookie(name) {
  return (
    document.cookie
      .split('; ')
      .find((row) => row.startsWith(name + '='))
      ?.split('=')[1] || ''
  )
}
